import styled from "styled-components";

export const PersonaMessage = styled.div`
  margin-top: ${(props: { index: number }) =>
    props.index === 0 ? `auto` : `0`};
  margin-bottom: 40px;

  .talk-bubble {
    display: inline-block;
    position: relative;
    background-color: #ffffff;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.15);
    padding: 27px 18px 17px;
    font-size: 16px;
    border-radius: 30px 30px 30px 5px;
  }

  .tri-right.btm-left:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left: 0px;
    right: auto;
    top: auto;
    bottom: -20px;
    border: 22px solid;
    border-color: transparent transparent transparent #ffffff;
  }

  /* talk bubble contents */
  .talktext {
    text-align: left;
  }
  .talktext p {
    /* remove webkit p margins */
    -webkit-margin-before: 0em;
    -webkit-margin-after: 0em;
  }
`;
